import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "You don't have to cross the chasm anymore",
  "description": "",
  "published": "2012-06-26T00:00:00.000Z",
  "redirect_from": ["/blog/?p=4745"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`blog o tem: `}<a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/217683349135822848"
      }}>{`https://twitter.com/Swizec/status/217683349135822848`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      